module.exports = {"420505001":"古老背街道","420505002":"虎牙街道","420505003":"云池街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420505.json
// module id = 1728
// module chunks = 0